// Lazy-loaded components for code splitting
const UserList = () =>
    import(/* webpackChunkName: "user" */ "./pages/ListPage.vue");
const UserDetail = () =>
    import(/* webpackChunkName: "user" */ "./pages/FormPage.vue");
const UserIndex = () =>
    import(/* webpackChunkName: "user" */ "./pages/IndexPage.vue");
const UserAccount = () =>
    import(/* webpackChunkName: "user" */ "./pages/AccountPage.vue");
export default [
    {
        path: "/user",
        component: UserIndex,
        redirect: "/user/list",
        name: "user",
        children: [
            {
                path: "list",
                component: UserList,
                name: "user.list",
            },
            {
                path: "create",
                component: UserDetail,
                name: "user.create",
                props: { create: true },
            },
            {
                path: "edit/:id",
                component: UserDetail,
                name: "user.edit",
                props: { create: false },
            },

            {
                path: "account",
                component: UserAccount,
                name: "user.account",
            },
        ],
    },
    /* Put account in another route so group permissions will not hide/disable it */
    {
        path: "/my-account",
        component: UserIndex,
        redirect: "/my-account/account",
        name: "my-account",
        children: [
            {
                path: "account",
                component: UserAccount,
                name: "my-account.account",
            },
        ],
    },
];
